import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PatientService {
  private baseUrl = environment.beServiceUrl;

  constructor(private http: HttpClient) {}

  findPatient(request: any) {
    const url = this.baseUrl + '/v2/anagrafica';
    return this.http.post<any>(url, request);
  }

  newPatient(request: any) {
    const url = this.baseUrl + '/v1/patient/insert';
    return this.http.post<any>(url, request);
  }

  checkFiscalCode(request: any) {
    const url = this.baseUrl + '/v1/patient/fiscal-code-check';
    return this.http.post<any>(url, request);
  }

  calculateFiscalCode(request: any) {
    const url = this.baseUrl + '/v1/patient/fiscal-code';
    return this.http.post<any>(url, request);
  }

  findTown(date: Date | string) {
    const url = this.baseUrl + '/v1/town?offset=0&limit=100000&referenceDate='+date;
    return this.http.get<any>(url);
  }
}
